import React, {useEffect, useMemo, useState} from 'react';
import {useHistory} from "react-router-dom";
import styles from "./styles.module.scss";
import {
    DocumentButton,
    FilterDropdown,
    ImageStamp,
    LightTextButton,
    Search,
    SearchButton, Status,
    StatusButton, SwitchButton, Table,
    TextInput,
    TextLink,
    PageNavigator,
} from "../../../components";
import TableSP from "../../../components/Table/TableSP";
import TableCommision from "../../../components/Table/TableCommision";
import {useDispatch, useSelector} from "react-redux";
import {adminToken, internalSearch} from "../../../helper";
import PackagesPopup from "../popups/Packages/PackagesPopup";
import {serviceProviderAction, spCommisionAction, categoryAction, subscriptionAction} from "../../../redux/actions";
import * as XLSX from "xlsx";
import SpNewModal from "../../ServiceProviderNew/SPNewModal";
import {Modal} from "@material-ui/core";
import axios from "axios";
import SubscriptionModal from "../../Customers/modals/SubscriptionModal";
import {IMAGE_URL} from "../../../configurations";
import clsx from "clsx";
import SPPaymentPopup from "../modals/SPPaymentPopup";
import { AWS_ROUTING, AWS_SERVER_APIS, AWS_SERVER_APIS_NEW } from "configurations";

const initialFilterState = {
    id: "",
    sp_id: "",
    subscription_id: ""
};

function SpCommisionPanel() {
    const history = useHistory();
    const currentLocation = history.location.pathname;

    // States
    const [tableRows, setTableRows] = useState();
    const [editableDetail, setEditableDetails] = useState();
    const [isPopupVisible, setPopupVisible] = useState();

    // Filter States
    const [status, setStatus] = useState();
    const [filterState, setFilterState] = useState(initialFilterState);
    const [filter, setFilter] = useState('');
    const [searchData, setSearchData] = useState('');
    const [spPayments, setSpPayments] = useState([]);
    const [cPage, setCPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [totalCount, setTotalCount] = useState();
    const [currentpayid, setCurrentpayid] = useState();
    const [spLoader, setSpLoader] = useState(false);
    const [subscriptionDatas, setsubscriptionDatas] = useState([])

    // Redux actions
    const dispatch = useDispatch();
    const {user, spCommisionReducer, categories, userRole} = useSelector(state => ({
        user: state.user,
        spCommisionReducer: state.spCommisionReducer,
        categories: state.categories,
        userRole: state.userRole?.filter(role => role.module === "SP Commissions")
    }));

    useEffect(() => {
        // console.log('userRole ========------>>>>'+JSON.stringify(userRole));
        if (userRole?.find(item => item.privilege === "Read")) {
            setSpLoader(true);
            adminToken().then(token => axios
                .get(
                    `${AWS_SERVER_APIS}/getsppayments?page=${cPage}&per_page=10&filter=${(filter)?filter:''}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                )
                .then(res => {
                    setSpPayments(res.data.data);
                    setLastPage(res.data.maxPages);
                    setTotalCount(res.data.totalCount);
                    dispatch(serviceProviderAction.get());
                    // dispatch(subscriptionAction.get());
                    if(res.data.maxPages == 1){
                        setCPage(1);
                    }
                    setSpLoader(false);
                })
            )
        }

        //return () => dispatch(serviceProviderAction.reset());
    }, [searchData,cPage]);

    useEffect(() => {
            let filtered = spPayments;

            if (!filtered?.length) {
                setTableRows();
                return;
            }

            // if (status !== 'All') {
            //     filtered = filtered?.filter(item => item.payment_status === status.toLowerCase());
            // }
            // filtered = internalSearch(filterState, "id", filtered);
            // filtered = internalSearch(filterState, "sp_id", filtered);
            // filtered = internalSearch(filterState, "subscription_id", filtered);

            filtered = filtered?.map(obj => ({
                id: obj.id,
                sp_id: <TextLink
                    text={obj.sp_id}
                    // onClick={() => history.push(`/sp-commisions/sp-commisions/${obj.sp_id}`)}
                    onClick={() => {
                        let sub = null;
                        // adminToken().then(token =>
                        //     axios.get(`https://cgapp.clykk.com/cart/api/v2/int/cart-management/cart/subscriptions/${obj.subscription_id}/detail`, {
                        //         headers: {
                        //             "Content-Type": "multipart/form-data",
                        //             Authorization: `Bearer ${token}`
                        //         }
                        //     })
                        //         .then(res => sub = res.data)
                        // )
                        setClickedSP({
                            id: obj.sp_id,
                            mobile: obj?.mobile,
                            name: obj?.firstName + " " + obj?.lastName,
                            categoryID: obj?.categoryID,
                            categoryName: categories?.find(item => item.id == obj.categoryID)?.name
                        })
                        handleOpenModal()
                    }}
                />,
                // subscription_id: obj.subscription_id,
                subscription_id: <TextLink
                    text={parseInt(obj.subscription_id)}
                    onClick={() => {
                        setClickedSubscription({id: obj.subscription_id, userId: null})
                        handleOpenSubscriptionModal()
                    }}
                />,
                serviceDate: obj.get_subscription_details[0].service_date,
                serviceTime: obj.get_subscription_details[0].service_time,
                amount: obj.amount,
                payment_status: <button
                    className={clsx('btn btn-primary w-75', obj?.payment_status === 'done' ? "btn-success" : "btn-warning")}
                    onClick={() => {
                        handleOpenModalSPPay(obj?.payment_status)
                        setCurrentpayid(obj.id)
                    }}
                    style={{textTransform: 'capitalize'}}>
                    {obj?.payment_status}
                </button>,
                create_by: obj.create_by,
                payment_date: `${(obj.payment_date)?new Date(obj.payment_date).toLocaleString():''}`,
                createdAt: `${new Date(obj.created_at).toLocaleString()}`,
                updatedAt: `${new Date(obj.updated_at).toLocaleString()}`
            }));

            setTableRows(filtered);
        },
        [spPayments, status, filterState,searchData,cPage]
    );

    // Table Header
    const tableHeaders = useMemo(
        () => [
            {
                title: "ID",
                sortBy: "id"
            },
            {
                title: "Provider",
                sortBy: "sp_id"
            },
            {
                title: "Subscription",
                sortBy: "subscription_id"
            },
            {
                title: "Service Date",
                sortBy: "serviceDate"
            },
            {
                title: "Service Time"
            },
            {
                title: "Amount",
            },
            {
                title: "Payment Status"
            },
            {
                title: "Paid By"
            },
            {
                title: "Payment Date"
            },
            {
                title: "Created"
            },
            {
                title: "Updated"
            }
        ],
        [tableRows]
    );

    const exportDataFunc = () => {

        const rows = tableRows.map(item => {
            return {
                "ID": item.id,
                "Provider": item.sp_id,
                "Subscription": item.subscription_id,
                "amount": item.amount,
                "Payment Status": item.payment_status,
                "Created By": item.create_by,
                "Created At": item.createdAt,
                "Updated At": item.updatedAt
            }
        })

        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
        //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
        XLSX.writeFile(workbook, "DataSheet.xlsx");
    }

    const [openModalSPPay, setOpenModalSPPay] = useState(false)
    const handleOpenModalSPPay = (status) => {
        const status_v = (status === 'done')?false:true;
        setOpenModalSPPay(status_v)
    }
    const handleCloseSPPay = () => {
        setOpenModalSPPay(false)
    }

    const [openModal, setOpenModal] = useState(false)
    const handleOpenModal = () => {
        setOpenModal(true)
    }
    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const [clickedSP, setClickedSP] = useState(null)
    const [clickedSubscription, setClickedSubscription] = useState(null)

    const [openSubscriptionModal, setOpenSubscriptionModal] = useState(false)

    const handleOpenSubscriptionModal = () => {
        setOpenSubscriptionModal(true)
    }

    const handleCloseSubscriptionModal = () => {
        setOpenSubscriptionModal(false)
    }

    const [value, setValue] = useState(0);

    // Search based on category & sub category name
    const onSearch = () => {
        setSearchData({filter});
    };

    // Clear Search
    const clearSearch = () => {
        setSearchData('');
        setFilter('');
    };

    return (
        <div>
            <div className={styles.filter}>
                <TextInput
                    label="Filter"
                    placeholder="Filter By Provider/Subscription"
                    name="search"
                    onChange={e => setFilter(e.target.value)}
                    value={filter}
                />

                <button className={'btn btn-primary m-auto search_commision'} style={{margin: 10}}
                        onClick={onSearch}
                >Search
                </button>&nbsp;&nbsp;

                <button className={'btn btn-info m-auto'} style={{margin: 10}}
                        onClick={clearSearch}
                >Clear
                </button>&nbsp;&nbsp;
            </div>

                <TableCommision
                headers={tableHeaders}
                data={(!spLoader)?tableRows:''}
                current={tableRows?.pageNumber}
                totalPage={Math.ceil(tableRows?.count / 10)}
                onPageChange=''
                state={filterState !== initialFilterState}
                length={totalCount}
                r_length={tableRows?.users?.length}
                t_length={tableRows?.count}
                exportData={false}
                spLoader={spLoader}
                spPayments={spPayments}
            />
            
            {(tableRows && !spLoader)?<PageNavigator
                    pageCount={lastPage}
                    currentPage={cPage}
                    onClick={e => {setCPage(e)}}
                />:''}


            
            {isPopupVisible && (
                <PackagesPopup
                    data={editableDetail}
                    closeModal={() => setPopupVisible(false)}
                />
            )}

            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <SpNewModal clickedSP={clickedSP} handleCloseModal={handleCloseModal} value={value} setValue={setValue}
                            setClickedSubscription={setClickedSubscription}
                            handleOpenSubscriptionModal={handleOpenSubscriptionModal}/>
            </Modal>

            <Modal
                open={openSubscriptionModal}
                onClose={handleCloseSubscriptionModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <SubscriptionModal clickedSubscription={clickedSubscription} handleCloseModal={handleCloseSubscriptionModal}/>
            </Modal>

            <Modal
                open={openModalSPPay}
                onClose={handleCloseSPPay}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <SPPaymentPopup handleCloseSPPay={handleCloseSPPay} spPayments={spPayments} currentpayid={currentpayid} setCPage={setCPage} />
            </Modal>

        </div>
    );
}

export default SpCommisionPanel;